export interface ICliente {
  id?: number;
  nombre?: string | null;
  cuit?: string | null;
  celular?: string | null;
  email?: string | null;
  nacimiento?: any | null;
}

export class Cliente implements ICliente {
  constructor(
    public id?: number,
    public nombre?: string | null,
    public cuit?: string | null,
    public celular?: string | null,
    public email?: string | null,
    public nacimiento?: any | null
  ) {}
}
